/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgInsurance24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M12 19.5S4.5 16.821 4.5 6.643L12 4.5l7.5 2.143C19.5 16.821 12 19.5 12 19.5z'
      />
      <circle cx={12} cy={11} r={2.25} stroke='#000' strokeWidth={1.5} />
      <path
        fill='#000'
        fillRule='evenodd'
        d='M12.206 3.779a.75.75 0 00-.412 0l-7.5 2.143a.75.75 0 00-.544.721c0 5.296 1.96 8.694 3.96 10.766a12.811 12.811 0 002.74 2.161c.376.22.692.375.918.478a6.749 6.749 0 00.345.145l.023.009.007.003h.003v.001c.001 0 .002 0 .254-.706l-.252.706a.75.75 0 00.504 0L12 19.5l.253.706h.001l.003-.001.007-.003.023-.009.077-.03c.065-.026.155-.064.268-.115.226-.103.542-.259.918-.478a12.812 12.812 0 002.74-2.16c2-2.073 3.96-5.471 3.96-10.767a.75.75 0 00-.544-.721l-7.5-2.143zm-.194 14.903l-.012.006-.012-.006a8.748 8.748 0 01-.782-.407 11.31 11.31 0 01-2.416-1.908c-1.681-1.74-3.4-4.607-3.532-9.16L12 5.28l6.742 1.926c-.132 4.554-1.85 7.42-3.532 9.161a11.309 11.309 0 01-2.416 1.908c-.327.19-.598.323-.782.407zM13.5 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm1.5 0a3 3 0 11-6 0 3 3 0 016 0z'
      />
    </svg>
  );
}

export default SvgInsurance24;
